module.exports = __webpack_public_path__ + "img/wel_bg.2ddff504.png";